import { render } from "./MainSlider.vue?vue&type=template&id=23303f00"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"

import "./MainSlider.vue?vue&type=style&index=0&id=23303f00&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__